/* eslint-disable radix */
import { TRACKING_KEY, TRACKING_EVENT, TRACKING_VALUE } from 'shared/constants';

export const trackingUserName = (tracking, name) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.NAME,
    value: name,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackFinancialGoal = (tracking, financialGoal) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.FINANCIAL_GOAL,
    value: financialGoal,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

/**
    Age 60 and above
    Age 50 - 59 yrs old
    Age 40 - 49 yrs old
    Age 30 - 39 yrs old
    Age 15 - 29 yrs old
 */
export const trackAge = (tracking, age) => {
  const filterAge = (value) => {
    if (value >= 60) {
      return TRACKING_VALUE.SIXTEEN_AND_ABOVE;
    }
    if (value >= 50 && value <= 59) {
      return TRACKING_VALUE.FIFTY_TO_FIFTYNINE;
    }
    if (value >= 40 && value <= 49) {
      return TRACKING_VALUE.FOURTY_TO_FOURTYNINE;
    }
    if (value >= 30 && value <= 39) {
      return TRACKING_VALUE.THIRTY_TO_THIRTYNINE;
    }
    return TRACKING_VALUE.FIFTEEN_TO_TWENTYNINE;
  };
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.AGE,
    value: filterAge(parseInt(age)),
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackInvestableAsset = (tracking, wealth) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.ESTIMATE_WEALTH,
    value: wealth,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
